import React from 'react';
import { Link } from 'react-router-dom';

const CTASection: React.FC = () => {
    return (
        <section
            id="cta"
            className="relative w-full min-h-screen flex flex-col justify-center items-start overflow-hidden bg-canvas border-0 outline-none py-24 md:py-32"
            aria-labelledby="cta-heading"
        >
            <div className="relative z-10 w-full px-6 md:px-24 lg:px-32 flex flex-col items-center text-center">
                <h2
                    id="cta-heading"
                    className="text-5xl md:text-7xl lg:text-8xl font-normal tracking-[-0.02em] mb-6 md:mb-8 text-text-primary leading-[1.1]"
                >
                    Start your 7-Day Free Trial
                </h2>

                <p className="text-lg md:text-xl text-text-primary leading-relaxed">
                    Stop listening to generic recordings. Experience the first<br />truly adaptive meditation engine.
                </p>

                <Link
                    to="/app"
                    className="mt-6 md:mt-8 inline-block text-lg text-text-primary whitespace-nowrap bg-transparent border border-primary px-5 py-2 rounded-full hover:bg-text-primary hover:text-canvas transition-colors focus-visible:outline-2 focus-visible:outline-text-primary focus-visible:outline-offset-4 focus:outline-none"
                >
                    Try Now
                </Link>
            </div>
        </section>
    );
};

export default CTASection;
